import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class PhoneNumberInput extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			icon,
			id,
			name,
			style,
			placeholder,
			value,
			onChange,
			helperText,
			fieldErrors
		} = this.props;

		return (
			<div className="PhoneNumberInput mt-2 mb-4">
				<input
					defaultCountry="US"
					className={`block border border-gray-300 w-full p-2 h-10 rounded " + ${icon
						? 'has-icon'
						: ''}`}
					id={id}
					name={name}
					style={style}
					placeholder={placeholder}
					value={value}
					onChange={onChange}
				/>
				<div className="p-1">
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
